// An app-wide signal that the user's token balance may have changed, so the Navbar
// can re-fetch it without a page reload.

export const BALANCE_CHANGED_EVENT = 'lab:balance-changed';

export const notifyBalanceChanged = () => {
    window.dispatchEvent(new CustomEvent(BALANCE_CHANGED_EVENT));
};

// Returns a function that removes the handler.
export const onBalanceChanged = (handler) => {
    const listener = () => handler();
    window.addEventListener(BALANCE_CHANGED_EVENT, listener);
    return () => window.removeEventListener(BALANCE_CHANGED_EVENT, listener);
};
